module.exports = __webpack_public_path__ + "img/emenu.1203e54d.webp";